import React, { useState } from "react";
import Header from "./Header/components/Header";
import SideBar from "./SideBar/components/SideBar";
import EventTable from "./EventTable/components/EventTable";

function App() {
  return (
    <React.Fragment>
      <Header />
      <SideBar></SideBar>

      <EventTable></EventTable>
    </React.Fragment>
  );
}

export default App;
